import { Typography, Box, Grid } from "@mui/material";

import { Option } from "api/common/types/common.types";
import { OrgStub } from "api/memberPortal/orgs/orgs.types";
import { AppFormType } from "components/Forms/AppForm";

import CSFCClaimOptions from "../../CSFCClaimOptions";

interface VendorInfoSectionProps {
  productForm:
    | AppFormType
    | { AppField: any; setFieldValue: any; handleSubmit: any };
  labVendors: OrgStub[];
}

const csfcClaimComponentOptions: Option[] = CSFCClaimOptions.map(
  (csfcOption) => ({
    value: csfcOption.name,
    label: csfcOption.name,
  }),
);

const csfcEligibleOptions = [
  { value: "Yes", label: "Yes" },
  { value: "No", label: "No" },
  { value: "Maybe", label: "Maybe" },
];

const VendorInfoSection = ({
  productForm,
  labVendors,
}: VendorInfoSectionProps) => {
  const labVendorsOptions = labVendors.map((vendor) => ({
    value: vendor.org_id,
    label: vendor.name,
  }));

  return (
    <Box className="mb-4">
      <Typography variant="body1" className="mb-2">
        VENDOR INFORMATION
      </Typography>
      <div className="border p-3 rounded">
        <Typography variant="body1" sx={{ mb: 3, color: "text.secondary" }}>
          Select the vendor, POC, Phone, and Email and if the vendor is
          interested in CSfC.
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <productForm.AppField name="vendor_id">
                {(field: any) => (
                  <field.SelectField
                    options={labVendorsOptions}
                    label="Vendor:"
                    style={{ width: "100%" }}
                    size="small"
                    required
                    data-cy="vendor"
                    onChange={(val: string) => {
                      //we need to set the vendor_phone, vendor_email, and vendor_poc fields to the values of the selected vendor
                      //@ts-ignore
                      productForm.setFieldValue(
                        "vendor_phone",
                        labVendors.find((vendor) => vendor.org_id === val)
                          ?.primary_phone,
                      );
                      //@ts-ignore
                      productForm.setFieldValue(
                        "vendor_email",
                        labVendors.find((vendor) => vendor.org_id === val)
                          ?.poc_email,
                      );
                      //@ts-ignore
                      productForm.setFieldValue(
                        "vendor_poc",
                        labVendors.find((vendor) => vendor.org_id === val)?.poc,
                      );
                    }}
                  />
                )}
              </productForm.AppField>
              <productForm.AppField name="vendor_phone">
                {(field: any) => (
                  <field.TextInput label="Vendor Phone:" type="tel" />
                )}
              </productForm.AppField>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <productForm.AppField name="vendor_poc">
                {(field: any) => <field.TextInput label="Vendor POC:" />}
              </productForm.AppField>

              <productForm.AppField name="vendor_email">
                {(field: any) => (
                  <field.TextInput label="Vendor Email:" type="email" />
                )}
              </productForm.AppField>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <productForm.AppField
              name="csfc.csfc_eligible"
              listeners={{
                onChange: ({ value }: { value: string }) => {
                  value === "No" &&
                    // @ts-ignore
                    productForm.resetField("csfc.csfc_components");
                },
              }}
            >
              {(csfcEligibleField: any) => (
                <>
                  <csfcEligibleField.SelectField
                    options={csfcEligibleOptions}
                    label="CSfC Eligible:"
                    style={{ width: "100%" }}
                    size="small"
                    required
                    data-cy="csfc-eligible"
                  />

                  {["Yes", "Maybe"].includes(csfcEligibleField.state.value) && (
                    <Grid item xs={12}>
                      <Typography
                        variant="body1"
                        sx={{ mt: 3, mb: 1, color: "text.secondary" }}
                      >
                        If &quot;Yes&quot; or &quot;Maybe&quot;, which
                        components are the vendor claiming for CSfC?*
                      </Typography>
                      <productForm.AppField name="csfc.csfc_components">
                        {(field: any) => (
                          <field.MultiAutocompleteSelect
                            options={csfcClaimComponentOptions}
                            label="Select Components:"
                            style={{ width: "100%" }}
                            size="small"
                          />
                        )}
                      </productForm.AppField>
                    </Grid>
                  )}
                </>
              )}
            </productForm.AppField>
          </Grid>
        </Grid>
      </div>
    </Box>
  );
};

export default VendorInfoSection;
